if (!customElements.get('product-editorial-sticky-atc')) {
  customElements.define(
    'product-editorial-sticky-atc',
    class ProductEditorialStickyAtc extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.atcSlot = this.productInfo?.querySelector('[data-editorial-atc-slot]');
        this.primaryPrice = this.atcSlot?.querySelector('.product-editorial__price');
        this.primaryButton = this.atcSlot?.querySelector('.product-form__submit');
        this.stickyPrice = this.querySelector('[data-editorial-sticky-price]');
        this.stickyButton = this.querySelector('[data-editorial-sticky-button]');
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

        if (!this.atcSlot || !this.primaryButton || !this.stickyButton) return;

        this.hidden = false;
        this.updateFrame = null;
        this.requestUpdate = this.requestUpdate.bind(this);
        this.handleStickyClick = this.handleStickyClick.bind(this);

        this.stickyButton.addEventListener('click', this.handleStickyClick);
        window.addEventListener('scroll', this.requestUpdate, { passive: true });
        window.addEventListener('resize', this.requestUpdate);
        this.mobileMediaQuery.addEventListener('change', this.requestUpdate);

        this.contentObserver = new MutationObserver(() => this.syncContent());
        this.contentObserver.observe(this.atcSlot, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        this.syncContent();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleStickyClick);
        window.removeEventListener('scroll', this.requestUpdate);
        window.removeEventListener('resize', this.requestUpdate);
        this.mobileMediaQuery?.removeEventListener('change', this.requestUpdate);
        this.contentObserver?.disconnect();
        if (this.updateFrame !== null) window.cancelAnimationFrame(this.updateFrame);
      }

      handleStickyClick() {
        if (!this.primaryButton.disabled && this.primaryButton.getAttribute('aria-disabled') !== 'true') {
          this.primaryButton.click();
        }
      }

      requestUpdate() {
        if (this.updateFrame !== null) return;
        this.updateFrame = window.requestAnimationFrame(() => {
          this.updateFrame = null;
          this.updateVisibility();
        });
      }

      syncContent() {
        if (this.primaryPrice && this.stickyPrice) {
          this.stickyPrice.innerHTML = this.primaryPrice.innerHTML;
        }

        const primaryLabel = this.primaryButton.querySelector('span');
        const stickyLabel = this.stickyButton.querySelector('span');
        if (primaryLabel && stickyLabel) stickyLabel.textContent = primaryLabel.textContent;

        this.stickyButton.disabled = this.primaryButton.disabled;
        this.stickyButton.classList.toggle('loading', this.primaryButton.classList.contains('loading'));

        const ariaDisabled = this.primaryButton.getAttribute('aria-disabled');
        if (ariaDisabled === null) {
          this.stickyButton.removeAttribute('aria-disabled');
        } else {
          this.stickyButton.setAttribute('aria-disabled', ariaDisabled);
        }
      }

      updateVisibility() {
        if (!this.mobileMediaQuery.matches) {
          this.classList.remove('is-visible');
          return;
        }

        const bounds = this.atcSlot.getBoundingClientRect();
        const shouldShow = bounds.bottom <= 0;
        this.classList.toggle('is-visible', shouldShow);
      }
    }
  );
}
